import { useEffect, useState } from 'react';
import Loading from '../Info/Loading';
import { getFormStructure } from './api';
import DynamicFormBase, { DynamicFormBaseProps } from './DynamicFormBase';

interface DynamicFormProps extends Omit<DynamicFormBaseProps, 'structure'> {
  formStructureUrl: string;
  readOnly?: boolean;
}

function DynamicForm(props: DynamicFormProps) {
  const [structure, setStructure] = useState<any>([]);

  useEffect(() => {
    async function fetchFormularioConfig() {
      try {
        //obtenemos la estructura del formulario: 1 student file, 2 sustainer
        const formStructure = await getFormStructure(props.formStructureUrl);
        setStructure(formStructure.data.sections);
      } catch (error) {
        console.error('Error al cargar la configuración del formulario', error);
      }
    }
    fetchFormularioConfig();
  }, [props.formStructureUrl]);

  if (!structure) {
    return <Loading insideCard textBody={'Cargando formulario'} />;
  }

  return <DynamicFormBase {...props} structure={structure} />;
}
export default DynamicForm;
